module.exports = __webpack_public_path__ + "static/media/up_arrow.7c3777e9.svg";